import axios from 'axios';
import { 
    API_BASE_URL
} from 'src/common/constants';

export default class KanbanboardService {
	static getInstance() {
		if (!KanbanboardService.instance) {
			KanbanboardService.instance = new KanbanboardService();
		}

		return KanbanboardService.instance;
	}

	async fetchManagersList(payload = {}, module = 'wb'){
		const response = await axios.post(`${API_BASE_URL}${module === 'cm' ? '/cm' : ''}/analystAndAdminAnalyst.list`, payload,
			{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
			}
		);

		return response.data?.data;
	}

	async fetchTaskOwners(payload = {}, module = 'wb'){
		const response = await axios.post(`${API_BASE_URL}${module === 'cm' ? '/cm' : ''}/analystAndAdminAnalystAndTaskOwners.list`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
			}
		);

		return response.data?.data;
	}
}
